<div class="header-container">
  <h3 class="header-title">{{customer.company_name}} ({{customer.pk}})</h3>
</div>
<div class="content">
  <nz-tabset nzType="card">
    <nz-tab [nzTitle]="infoTemplate">
      <ng-template #infoTemplate>
        <span nz-icon nzType="info-circle" nzTheme="outline"></span>
        Info
      </ng-template>
      <nz-skeleton [nzActive]="true" *ngIf="infoLoading"></nz-skeleton>
      <div *ngIf="!infoLoading" class="customer-data">
        <ng-container [ngTemplateOutlet]="tplContent"></ng-container>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="importerAccountTemplate" [nzDisabled]="infoLoading || !customer.pk">
      <ng-template #importerAccountTemplate>
        <span nz-icon nzType="audit" nzTheme="outline"></span>
        Datasource
      </ng-template>
      <ng-template nz-tab>
        <importer-accounts [customer]="customer"></importer-accounts>
      </ng-template>
    </nz-tab>
    <nz-tab [nzTitle]="featuresTemplate" [nzDisabled]="infoLoading || !customer.pk">
      <ng-template #featuresTemplate>
        <span nz-icon nzType="appstore-add" nzTheme="outline"></span>
        Features
      </ng-template>
      <ng-template nz-tab>
        <customer-features [customer]="customer"></customer-features>
      </ng-template>
    </nz-tab>
    <nz-tab [nzTitle]="filterTemplate" [nzDisabled]="infoLoading || !customer.pk">
      <ng-template #filterTemplate>
        <span nz-icon nzType="filter" nzTheme="outline"></span>
        Filter
      </ng-template>
      <ng-template nz-tab>
        <tt-filter [customer]="customer"></tt-filter>
      </ng-template>
    </nz-tab>
    <nz-tab [nzTitle]="usersTemplate" [nzDisabled]="infoLoading || !customer.pk || usersLoading">
      <ng-template #usersTemplate>
        <span nz-icon nzType="team" nzTheme="outline"></span>
        <span style="display: inline-flex; align-items: center; gap: 4px;">Users <span *ngIf="!usersLoading">({{this.usersList.length}})</span><nz-spin nzSimple nzSize="small" *ngIf="usersLoading"></nz-spin> </span>
      </ng-template>
      <ng-template nz-tab>
        <customer-users [users]="usersList" [customer]="customer" ></customer-users>
      </ng-template>
    </nz-tab>
    <nz-tab [nzTitle]="keyAccountsTemplate" [nzDisabled]="infoLoading || !customer.pk || keyAccountsLoading">
      <ng-template #keyAccountsTemplate>
        <span nz-icon nzType="folder" nzTheme="outline"></span>
        <span style="display: inline-flex; align-items: center; gap: 4px;">Key Accounts <span *ngIf="!keyAccountsLoading">({{this.keyAccountsList.length}})</span><nz-spin nzSimple nzSize="small" *ngIf="keyAccountsLoading"></nz-spin> </span>
      </ng-template>
      <ng-template nz-tab>
        <customer-keyaccounts [keyAccounts]="keyAccountsList" [customer]="customer"></customer-keyaccounts>
      </ng-template>
    </nz-tab>
    <nz-tab [nzTitle]="locationsTemplate" [nzDisabled]="infoLoading || !customer.pk">
      <ng-template #locationsTemplate>
        <span nz-icon nzType="global" nzTheme="outline"></span>
        Locations
      </ng-template>
      <ng-template nz-tab>
        <customer-locations [customer]="customer"></customer-locations>
      </ng-template>
    </nz-tab>
    <nz-tab [nzTitle]="columnsTemplate" [nzDisabled]="infoLoading || !customer.pk">
      <ng-template #columnsTemplate>
        <span nz-icon nzType="database" nzTheme="outline"></span>
        Data attributes
      </ng-template>
      <ng-template nz-tab>
        <customer-data-attributes [customer]="customer" ></customer-data-attributes>
      </ng-template>
    </nz-tab>
    <nz-tab [nzTitle]="apiTemplate" [nzDisabled]="infoLoading || !customer.pk">
      <ng-template #apiTemplate>
        <span nz-icon nzType="api" nzTheme="outline"></span>
        API
      </ng-template>
      <ng-template nz-tab>
        <api-keys [customer]="customer"></api-keys>
      </ng-template>
    </nz-tab>
    <nz-tab [nzTitle]="dashboardTemplate" [nzDisabled]="infoLoading || !customer.pk || usersLoading || keyAccountsLoading">
      <ng-template #dashboardTemplate>
        <span nz-icon nzType="dashboard" nzTheme="outline"></span>
        Dashboard
      </ng-template>
      <ng-template nz-tab>
        <customer-dashboard [customer]="customer" [users]="usersList" [keyAccounts]="keyAccountsList"></customer-dashboard>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</div>
<ng-template #tplContent>
  <form nz-form class="customer-form" #customerForm="ngForm">
    <div class="customer-info">
      <div>
        <nz-divider nzText="Company" [nzOrientation]="'left'"></nz-divider>
        <nz-form-item>
          <nz-form-label [nzSm]="24" [nzXs]="24" nzLabelAlign="left" nzRequired>Company name</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback nzErrorTip="Company name is required">
            <input nz-input [(ngModel)]="customer.company_name" (ngModelChange)="onFormChange()" name="company_name" required="true"
                   placeholder="Mustermann GmbH"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzLabelAlign="left" [nzSm]="24" [nzXs]="24" nzRequired>Admin Name</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback nzErrorTip="Admin name is required">
            <input nz-input [(ngModel)]="customer.admin_name" (ngModelChange)="onFormChange()" name="admin_name" required="true"
                   placeholder="Max Mustermann"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzLabelAlign="left" [nzSm]="24" [nzXs]="24" nzRequired>Admin Email</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback nzErrorTip="Admin Email is required">
            <input nz-input [(ngModel)]="customer.admin_email" (ngModelChange)="onFormChange()" name="admin_email" required="true"
                   placeholder="m.mustermann@muster.de" [readonly]="customer.pk"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzLabelAlign="left" [nzSm]="24" [nzXs]="24">Group ID</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24">
            <input nz-input [(ngModel)]="customer.group_id" (ngModelChange)="onFormChange()" name="group_id"
                   placeholder="de000019"/>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div>
        <nz-divider nzText="Billing" [nzOrientation]="'left'"></nz-divider>
        <div nz-row [nzGutter]="[16,0]">
          <div nz-col [nzSpan]="16">
            <nz-form-label nzRequired>Street</nz-form-label>
            <nz-form-item>
              <nz-form-control nzHasFeedback>
                <input nz-input [(ngModel)]="customer.billing_address_street" (ngModelChange)="onFormChange()" name="billing_address_street"
                       placeholder="Musterstraße" required="true"/>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="8">
            <nz-form-label nzRequired>Nr.</nz-form-label>
            <nz-form-item>
              <nz-form-control nzHasFeedback>
                <input nz-input [(ngModel)]="customer.billing_address_street_no" (ngModelChange)="onFormChange()" name="billing_address_street_no"
                       placeholder="132" required="true"/>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row [nzGutter]="[16,0]">
          <div nz-col [nzSpan]="8">
            <nz-form-label nzRequired>Zip code</nz-form-label>
            <nz-form-item>
              <nz-form-control nzHasFeedback>
                <input nz-input [(ngModel)]="customer.billing_address_zip_code" (ngModelChange)="onFormChange()" name="billing_address_zip_code"
                       placeholder="20253" required="true"/>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="8">
            <nz-form-label nzRequired>City</nz-form-label>
            <nz-form-item>
              <nz-form-control nzHasFeedback>
                <input nz-input [(ngModel)]="customer.billing_address_city" (ngModelChange)="onFormChange()" name="billing_address_city"
                       required="true" placeholder="Hamburg"/>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="8">
            <nz-form-label nzRequired>Country</nz-form-label>
            <nz-form-item>
              <nz-form-control nzHasFeedback>
                <nz-select nzPlaceHolder="Country" [(ngModel)]="customer.billing_address_country" (ngModelChange)="onFormChange()" name="billing_address_country" required="true"
                           style="width: 100%;">
                  <nz-option nzLabel="Germany" nzValue="Germany"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <nz-form-item>
          <nz-form-label nzLabelAlign="left" [nzSm]="24" [nzXs]="24" nzRequired>Contact Phone</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback nzErrorTip="Contact Phone is required">
            <input nz-input [(ngModel)]="customer.billing_address_phone" (ngModelChange)="onFormChange()" name="billing_address_phone" required="true"
                   placeholder="+1234567890"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox [(ngModel)]="customer.exclude_statistics" name="exclude_statistics" (ngModelChange)="onFormChange()">
              Exclude from MixPanel statistics
            </label>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div>
        <nz-divider nzText="Employees" [nzOrientation]="'left'"></nz-divider>
        <nz-form-label>Expected Users</nz-form-label>
        <nz-form-control>
            <input nz-input [(ngModel)]="customer.employees" (ngModelChange)="onFormChange()" name="employees"/>
        </nz-form-control>
      </div>
      <div>
        <nz-divider nzText="Decision-Maker" [nzOrientation]="'left'" s></nz-divider>
        <div nz-row [nzGutter]="[16,0]">
          <div nz-col [nzSpan]="16">
            <nz-form-label>Decision maker name</nz-form-label>
            <nz-form-control>
              <input nz-input [(ngModel)]="customer.decision_maker_name" (ngModelChange)="onFormChange()" name="decision_maker_name"/>
            </nz-form-control>
          </div>
          <div nz-col [nzSpan]="16">
            <nz-form-label>Decision maker email</nz-form-label>
            <nz-form-control>
              <input nz-input [(ngModel)]="customer.decision_maker_email" (ngModelChange)="onFormChange()" name="decision_maker_email"/>
            </nz-form-control>
          </div>
          <div nz-col [nzSpan]="16">
            <nz-form-label>Decision maker role</nz-form-label>
            <nz-form-control>
              <nz-select [(ngModel)]="customer.decision_maker_role" (ngModelChange)="onFormChange()" name="decision_maker_role">
                <nz-option [nzValue]="'Executive'" [nzLabel]="'Executive'"></nz-option>
                <nz-option [nzValue]="'Manager'" [nzLabel]="'Manager'"></nz-option>
                <nz-option [nzValue]="'Employee'" [nzLabel]="'Employee'"></nz-option>
              </nz-select>
            </nz-form-control>
          </div>
        </div>
      </div>
      <div>
        <nz-divider nzText="Data Provider" [nzOrientation]="'left'"></nz-divider>
        <div nz-row [nzGutter]="[24,0]">
          <div nz-col [nzSpan]="24">
            <label nz-checkbox [(ngModel)]="customer.is_data_provider" (ngModelChange)="onFormChange()" name="is_data_provider">Is data provider</label>
          </div>
        </div>
      </div>
      @if(isCreatingCustomer) {
        <div>
          <nz-divider nzText="Leading data set" [nzOrientation]="'left'"></nz-divider>
          <nz-form-item>
            <nz-form-label nzLabelAlign="left" [nzSm]="24" [nzXs]="24" nzRequired>
              Leading data set
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback nzErrorTip="Leading data set is required">
              <nz-select name="matching_rule" [(ngModel)]="customerMatchingRule!.matching_rule" (ngModelChange)="onFormChange()"
                [nzLoading]="matchingRuleLoading" [nzDisabled]="matchingRuleLoading" required nzAllowClear>
              @for (option of matchingRules | async; track $index) {
                <nz-option [nzValue]="option" [nzLabel]="matchingMap.get(option)!"> </nz-option>
              }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      }
    </div>
    <div class="customer-action">
      <button [disabled]="!customerForm.valid || !this.formChanged"
              (click)="saveChanges(customerForm)" [nzLoading]="saving"
              nz-button nzSize="large" nzType="primary" nzDanger>
        <span nz-icon nzType="save" nzTheme="outline"></span>
        {{!customer.pk ? "Create Tenant" : "Save changes"}}
      </button>
    </div>
  </form>
  <nz-divider></nz-divider>
  <div class="rules">
    @if(customerMatchingRule && !isCreatingCustomer) {
    <nz-card>
      <div class="rule">
        <h3>Leading data set <span nz-icon nzType="info-circle" nzTheme="twotone" nzTwotoneColor="#1663d2" nz-popover [nzPopoverContent]="leadingdata"></span></h3>
        <form #customerMatchingForm="ngForm">
          <nz-select name="customerMatchingRule" [(ngModel)]="customerMatchingRule!.matching_rule" style="width: 280px;"
            [nzLoading]="matchingRuleLoading" [nzDisabled]="matchingRuleLoading">
            @for (option of matchingRules | async; track $index) {
              <nz-option [nzValue]="option" [nzLabel]="matchingMap.get(option)!"></nz-option>
            }
          </nz-select>
        </form>
        <button [disabled]="!customerMatchingForm.dirty" nz-button nzType="primary" nzDanger [nzLoading]="matchingRuleLoading" (click)="saveMatchingRule(customerMatchingForm)">Save</button>
      </div>
      <div style="margin-top: 8px">⚠️ <strong>Changes have no effect on Data attributes</strong></div>
    </nz-card>
    }
    @if(customerArchivingRule) {
    <nz-card>
      <div class="rule">
        <h3>Archiving rule <span nz-icon nzType="info-circle" nzTheme="twotone" nzTwotoneColor="#1663d2" nz-popover [nzPopoverContent]="archive"></span></h3>
        <form #customerArchivingForm="ngForm">
          <nz-select name="customerArchivingForm" [(ngModel)]="customerArchivingRule!.archiving_rule" style="width: 280px;"
            [nzLoading]="archivingRuleLoading" [nzDisabled]="archivingRuleLoading">
            @for (option of archivingRules | async; track $index) {
              <nz-option [nzValue]="option" [nzLabel]="archivingMap.get(option)!"></nz-option>
            }
          </nz-select>
        </form>
        <button [disabled]="!customerArchivingForm.dirty" nz-button nzType="primary" nzDanger [nzLoading]="archivingRuleLoading" (click)="saveArchivingRule(customerArchivingForm)">Save</button>
      </div>
    </nz-card>
    }
  </div>
</ng-template>
<ng-template #leadingdata>
  <div style="max-width: 400px">
    <p class="info"><span nz-icon nzType="info-circle" nzTheme="twotone" nzTwotoneColor="#1663d2"></span>Here you can set the leading data record for this Tenant.</p>
    <p>MA data is for pure manufacturer data.</p>
    <p>PLC data is for the 100% leasing view, which is enriched with manufacturer data when there is a match.</p>
    <p>PFM and PLC data is for fleet management, which sees its data and the leasing data, which is then enriched with manufacturer data.</p>
  </div>
</ng-template>
<ng-template #archive>
  <div style="max-width: 400px">
    <p class="info"><span nz-icon nzType="info-circle" nzTheme="twotone" nzTwotoneColor="#1663d2"></span> Here you can set when data is moved to the archive.</p>
    <p>MA Rule moves a manufacturer record to the archive after 7 days without an update, or when the manufacturer end tracking has been reached.</p>
    <p>PLC Rule moves a leasing record to the archive after 7 days without an update, or when the registration date is set. If there was a match, it is moved to the archive as soon as manufacturer end tracking is reached.</p>
    <p>PMF Rule [will follow.... as soon as it is implemented]</p>
  </div>
</ng-template>
